import script from "./TONAddressTransactions.vue?vue&type=script&setup=true&lang=js"
export * from "./TONAddressTransactions.vue?vue&type=script&setup=true&lang=js"

import "./TONAddressTransactions.vue?vue&type=style&index=0&id=d219f424&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d219f424"]])

export default __exports__